import React, { useRef, useState, useEffect } from "react";
import { Outlet } from 'react-router-dom'; // If using React Router
import Sidebar from "../components/Sidebar";
import Topbar from '../components/Topbar';
import Bottombar from '../components/Bottombar';


const MainLayout = () => {
	const headerRef = useRef(null);
	const [sidebarOpen, setSidebarOpen] = useState(true);
	useEffect(() => {
	const handleResize = () => {
		if (window.innerWidth < 768) {
			setSidebarOpen(false);
		  } else {
			setSidebarOpen(true);
		  }
		};
		handleResize();
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);
	return (
    <>
		<div className="flex min-h-screen bg-gray-100 overflow-hidden">
			<Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />
			<div
			  className={`flex-1 flex flex-col transition-all duration-300`}
			  style={{
				marginLeft: sidebarOpen ? "0px" : "64px", // matches sidebar width
			  }}
			>
				<Topbar ref={headerRef} />		
				<main className="flex-1 overflow-y-auto">
					<Outlet /> {/* Renders nested routes/components */}
				</main>
			</div>
		</div>
		<Bottombar />
    </>
	);
};

export default MainLayout;